import { userManager } from '@/Core/Managers'

import { LoadDefaultCurrencyTask } from './LoadDefaultCurrencyTask'

import type { RequestFormContextLike } from '../Contracts/IRequest'

const isBlank = (value: unknown): boolean =>
    value === undefined || value === null || value === '' || (Array.isArray(value) && value.length === 0)

/** Поточний користувач — значенням select-а «Відповідальний» (ядро впізнає вибране за `@id`). */
const currentUserRef = (): Record<string, unknown> | null => {
    const user = userManager.user as Record<string, unknown>
    const uuid = typeof user['uuid'] === 'string' ? user['uuid'] : null

    if (!uuid) return null

    return { ...user, '@id': typeof user['@id'] === 'string' ? user['@id'] : `/services/users/${uuid}`, uuid }
}

/**
 * Значення форми створення запиту (`SPEC-022` §5.1):
 *
 *  - **«Відповідальний» — той, хто створює** (ЗП-06, легасі `RequestCrud.jsx:19`);
 *  - **валюта ціни — EUR** (ЗП-04).
 *
 * Пише лише в порожні поля й через `setInitialValue`: значення, яке вже
 * підставила вкладка клієнта чи вибрала людина, не перезаписується, а
 * дефолт не рахується незбереженою зміною.
 */
export const ApplyRequestCreateDefaultsTask = async (formContext: RequestFormContextLike): Promise<void> => {
    if (isBlank(formContext.values?.['responsible'])) {
        const user = currentUserRef()

        if (user) formContext.setInitialValue?.('responsible', user)
    }

    if (!isBlank(formContext.values?.['offeredPriceCurrency'])) return

    const currency = await LoadDefaultCurrencyTask()

    if (currency && isBlank(formContext.values?.['offeredPriceCurrency'])) {
        formContext.setInitialValue?.('offeredPriceCurrency', currency)
    }
}
